<div class="modal-header">
  @if (!data.expiredSession) {
    <h2 mat-dialog-title>Your session is about to expire!</h2>
  }
  @if (data.expiredSession) {
    <h2 mat-dialog-title>Your session has been expired!</h2>
  }

  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  @if (!data.expiredSession && data.countdown > 60) {
    <app-progress-bar color="warn" mode="determinate" [value]="(data.countdown / 60 * 100) / 15"></app-progress-bar>
    <p>You'll be logged out in {{data.countdown / 60 | number:'1.0-0'}} minute(s).</p>
  }
  @if (!data.expiredSession && data.countdown <= 60) {
    <app-progress-bar color="warn" mode="determinate" [value]="(data.countdown * 100) / 60"></app-progress-bar>
    <p>You'll be logged out in {{data.countdown / 60 | number:'1.0-0'}} minute(s).</p>
  }

  @if (data.expiredSession) {
    <p>This session is no longer active.  Login again to continue working.</p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="button" mat-dialog-close>OK</button>
</mat-dialog-actions>
